import CCColors from '@/Utils/CCColors';
import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  // container: {flexDirection: 'row'},
  // left: {flex: 0.2, padding: 20},
  // center: {flex: 0.5},
  // right: {flex: 0.3, padding: 10},
  addNewBox: {
    width: '100%',
    padding: 10,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: 'rgba(107, 88, 77, 0.2)',
    backgroundColor: '#FFFFFF',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: 6,
    transitionProperty: 'all',
    transitionDuration: '0.2s',
  },
  stickyButtonWrapper: {
    padding: 14,
    paddingTop: 10,
    backgroundColor: CCColors?.White,
    borderTopWidth: 1,
    borderTopColor: 'rgba(38,35,34,0.1)',
  },
  // participantsName: {
  //   padding: 10,
  //   elevation: 5,
  //   marginVertical: 5,
  //   flexDirection: 'row',
  //   justifyContent: 'space-between',
  // },
  // selectedName: {
  //   backgroundColor: CCColors.Primary.lightBrown,
  //   borderRadius: 8,
  //   elevation: 5,
  // },
});
